module.exports = __webpack_public_path__ + "img/40_38_050_690.d24d279a.jpg";